




import { Vue, Component } from "vue-property-decorator";
import Warning from "@/views/warning/Warning.vue";
import { COMP_FIELD } from "@/app-data/warning/warning";

@Component({
  components: { Warning }
})
export default class CompetitorWarning extends Vue {
  get categoryField() {
    return COMP_FIELD;
  }
};
